import exerciseStyles from "./exercise.module.less";
import {message,Button, Radio, Col, ConfigProvider, Layout, Pagination, Row, Tabs, Input, Modal, Popconfirm } from 'antd';
import {ArrowRightOutlined,PlusOutlined, GlobalOutlined, UserOutlined,EditOutlined,CheckCircleOutlined,CheckSquareOutlined,SearchOutlined,CodeOutlined,SortDescendingOutlined} from '@ant-design/icons'
import React, { useEffect, useRef, useState } from "react";
import zhCN from 'antd/lib/locale/zh_CN'
import { Tag } from 'antd';
import Cookies from 'js-cookie';
import courseMainStyles from "../course/course-main.module.less";
import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you
import emptyExercise from "../../static/image/empty/queshengye-timu.png";
import { sendHttpPostRequest } from "../../api/http-request";
import { checkUserLogin } from "../common/user-center/user-info";
import Draggable from "react-draggable";
import GlobalCss from '@/global.module.less'

const { CheckableTag } = Tag;

const {TabPane} = Tabs


export interface Props {}
export const ExerciseList: React.FC<Props> = (props) => {

    const [exerciseResult, setExerciseResult] = useState(null as any);  // 当前显示的结果页
    const [resultSum, setResultSum] = useState(0);  // 当前显示的结果页
    const queryContent = useRef('');  // 记录搜索串
    const querySource = useRef('2');  // 来源 1-个人  2-OAM创建（系统）
    const order = useRef('');  // 排序升序降序
    const order_by = useRef('');  // 排序列
    const page = useRef(1);  // 记录当前的页数
    const pageSize = useRef(9);  // 记录当前每页展示数量
    const typeFilters = useRef([] as any[]);  // 类型过滤选项
    const difficultyFilters = useRef([] as any[]);  // 难易程度过滤选项
    const createTime = useRef('');  // 创建时间
    const isMy = useRef(2); // 2-查公开上架的 1-查我的
    const isTeacher = useRef(false);  // 是否为教师

    const [selectedType, setSelectedType] = useState(1) //创建习题时选择的题型
    const newName = useRef('') // 名称

    const [isLogin, setIsLogin] = useState(false);//是否登录
    const [collegeId, setCollegeId] = useState(null as any);  // 院校ID
    const typesData = ["全部", '实操题', '单选题', '多选题', '排序题', '主观题']
    const difficultyData = ["全部", '容易', '中等', '困难']

    const [selectedDifficulty, setSelectedDifficulty] = useState([0] as number[]) // 筛选的难度
 
    const [selectedTypes,setSelectedTypes] = useState([0] as number[]) //筛选的题型
    const [isCollegeTeacher, setIsCollegeTeacher] =  useState(null as any);//当前机构是否是机构的教师

    /** 以下是创建习题弹出框显示用到的变量和函数 */
    const [isModalVisible, setIsModalVisible] = useState(false)

    const draggleRef = useRef<HTMLDivElement | null>(null)
  
    const [bounds,setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
    const [disabled,setDisabled] = useState(true)
  
    const onStart = (event:any, uiData:any) => {
      const { clientWidth, clientHeight } = window?.document?.documentElement;
      const targetRect= draggleRef?.current?.getBoundingClientRect();
      if(targetRect){
        setBounds( {
          left: -targetRect?.left + uiData?.x,
          right: clientWidth - (targetRect?.right - uiData?.x),
          top: -targetRect?.top + uiData?.y,
          bottom: clientHeight - (targetRect?.bottom - uiData?.y),
        }
      )
      }
    }
  
    const [isExeCardModalVisible, setIsExeCardModalVisible] = useState(false);
    const [exeCardModalbounds,setExeCardModalbounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
    const [exeCardModalDisabled,setExeCardModalDisabled] = useState(true)
  
    const onExeCardModalStart = (event:any, uiData:any) => {
      const { clientWidth, clientHeight } = window?.document?.documentElement;
      const targetRect= draggleRef?.current?.getBoundingClientRect();
      if(targetRect){
        setExeCardModalbounds( {
          left: -targetRect?.left + uiData?.x,
          right: clientWidth - (targetRect?.right - uiData?.x),
          top: -targetRect?.top + uiData?.y,
          bottom: clientHeight - (targetRect?.bottom - uiData?.y),
        }
      )
      }
    }


    useEffect(()=>{
        sendHttpPostRequest(
            'account/api/query_teacher_authenticate',{
                sessionid: Cookies.get("sessionid"),
                sid: Cookies.get("sessionid"),
            },
            (response:any)=>{
                if(response.is_ok == true)
                {
                    setIsLogin(true);
                    if (response?.college_info?.college_id !== '') { //已加入机构
                        let _collegeId = response.college_info.college_id; 
                        setCollegeId(_collegeId);
                        setIsCollegeTeacher(response.college_info.is_college_teacher);
                    }else{//未加入机构
                        setCollegeId(0);
                    }
                }else {//用户未登录
                    setIsLogin(false);
                }
            }
            )
        queryExerciseList();
    },[])

    const handleOk = () => { //确认创建习题
        createExercise();
    }

    const showModal = () => {
        if (!checkUserLogin()) {
            document.getElementById("show-login-modal")!.click();
        } else {
            //if (!checkIsTeacher()) {
                //document.getElementById("show-teacher-authenticate")!.click();
            //} else {
                isTeacher.current = true;
                setIsModalVisible(true);
            //}
        }
    };

    const handleCancel = () => {
      setIsModalVisible(false)
      newName.current = ''
    }

    /**
     * 查询习题列表
     */
     const queryExerciseList = () => {
        sendHttpPostRequest(
            'exercise/api/query_exercise_list/',
            {
                sessionid: Cookies.get("sessionid"),
                query: queryContent.current,
                page: page.current,
                pagesize: pageSize.current,
                order: order.current,
                order_by: order_by.current,
                type: JSON.stringify(typeFilters.current),
                difficulty: JSON.stringify(difficultyFilters.current),
                create_time: createTime.current,
                source: querySource.current,
                is_my: isMy.current,
                source_page: 1,  // 习题模块1
                source_key: isTeacher.current ? 3 : 4,  // 教师做题3  学生做题4
            },
            queryExerciseListCallback,
        )
    }

    /**
     * 查询习题列表回调
     * @param response
     */
    const queryExerciseListCallback = (response: any) => {
        message.destroy();
        //if (response.code == -100) {
            // 未登录
            //document.getElementById("show-login-modal")!.click();
            //setExerciseResult([]);
            //setResultSum(0);
            //setTotalCount(0);
            // window.location.href = '/login?next=exercise';
        //} else
        if (response.code == 0) {
            // 成功
            setExerciseResult(response.exercise_list);
            setResultSum(response.total_sum);
            //setTotalCount(response.total_count);
 
        } else if (response.code == -501) {
            // 权限不足
            //document.getElementById("show-login-modal")!.click();
            // window.location.href = '/login?next=exercise';
        } else {
            message.error(response.message);
        }
    }

  
    // 切换Tab页
    const onTabKeyChange = (key:string) => {
        console.log(key);
        querySource.current = key;
        page.current = 1;
        isMy.current = parseInt(key);
        queryExerciseList();
    }
    //点击了搜索按钮
    const onSearchBtn = (event: any) => {
        page.current = 1;
        queryContent.current = event.target.value;
        queryExerciseList();
    }



    //页码和页数发生了变化
    const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
        page.current = newPage ? newPage : 1;
        if (newPageSize) {
            pageSize.current = newPageSize;
        }
        queryExerciseList();
    }

    // 删除习题回调
    const deleteExerciseCallback = (response: any) => {
        message.destroy();
        if (response.code == -100) {
            // 没登录
                    sessionStorage.setItem("previousurl",window.location.href )
                    document.getElementById("show-login-modal")!.click();
        } else if (response.code == -501) {
            // 没权限
            message.error("您还没有教师权限");
            // window.location.href = '/login?next=exercise';
        } else if (response.code == 0) {
             //message.success("习题删除成功");
             queryExerciseList();
        } else {
            message.error(response.message);
        }
    }

    // 删除习题
    const deleteExercise = (exerciseId: string) => {
        sendHttpPostRequest(
            'exercise/api/delete_exercise/',
            {
                exercise_id: parseInt(exerciseId),
                sessionid: Cookies.get("sessionid"),
                sid: Cookies.get("sessionid")
            },
            deleteExerciseCallback
        )
    }

    /**
     * 创建习题回调
     * @param response
     */
    const setUserExerciseInfoCallback = (response:any) => {
        message.destroy();
        if (response.code == -100) {
            // 没登录
                    sessionStorage.setItem("previousurl",window.location.href )
                    document.getElementById("show-login-modal")!.click();
        } else if (response.code == -501) {
            // 没权限
            message.error("您还没有教师权限");
            // window.location.href = '/exercise';
        } else if (response.code == 0) {
                window.open(`/exercise-edit?exercise_id=${response.exercise_id}`);
                queryExerciseList();
                setIsModalVisible(false);
        }else{
            message.error(response.message);
        }
    }

    /**
     * 点击创建习题
     */
    const createExercise = () => {
        sendHttpPostRequest(
            'exercise/api/create_exercise/',
            {

                sessionid: Cookies.get("sessionid"),
                type: selectedType,
                title: newName.current,
            },
            setUserExerciseInfoCallback
        )
        newName.current = ''
    }

    const getExeTypeLabeStyle = (type:number)=> {
        if(type == 1) {
            return {fontSize:12,color:'#ea580c', background:'rgb(255 247 237)', borderRadius:999, padding:'4px 10px'}
        }else if(type == 2) {
            return {fontSize:12,color:'rgb(37 99 235)', background:'rgb(239 246 255)', borderRadius:999, padding:'4px 10px'}
        }else if(type == 3) {
            return {fontSize:12,color:'#9333EA', background:'#FAF5FF', borderRadius:999, padding:'4px 10px'}
        }else if(type == 4) {
            return {fontSize:12,color:'#db2777', background:'#fdf2f8', borderRadius:999, padding:'4px 10px'}
        
        }else {
            return {fontSize:12,color:'#4fe6e5', background:'#eef2ff', borderRadius:999, padding:'4px 10px'}
        }
    }

    const getTypeName = (type:number)=> {
        if(type == 1) {
            return "实操题"
        }else if(type == 2) {
            return "单选题"
        }else if(type == 3) {
            return "多选题"
        }else if(type == 4) {
            return "排序题"
        
        }else {
            return "主观题"
        }
    }


    const getExeDifficultLabeStyle = (type:number)=> {
        if(type == 1) {
            return {fontSize:12,color:'#16A34A', background:'#F0FDF4', borderRadius:999, padding:'4px 10px'}
        }else if(type == 2) {
            return {fontSize:12,color:'#CA8A04', background:'#FEFCE8', borderRadius:999, padding:'4px 10px'}
        }else if(type == 3) {
            return {fontSize:12,color:'#DC2626', background:'#FEF2F2', borderRadius:999, padding:'4px 10px'}
        }
    }

    const getDifficultName = (type:number)=> {
        if(type == 1) {
            return "容易"
        }else if(type == 2) {
            return "中等"
        }else if(type == 3) {
            return "困难"
        }
    }



    const onExerciseCardClick = (exercise_id: any,event: any) => {
        event.preventDefault();
        event.stopPropagation()
        if (!checkUserLogin()) {
            document.getElementById("show-login-modal")!.click();
        } else if(isCollegeTeacher == 1){
                window.open('/exercise-preview?exercise_id=' + exercise_id);
        }else {
            setIsExeCardModalVisible(true);
        }
    }

    const onExerciseEditClick = (exercise_id: any,event: any) => {
        event.preventDefault();
        event.stopPropagation()
        if (!checkUserLogin()) {
            document.getElementById("show-login-modal")!.click();
        } else {
            window.open('/exercise-edit?exercise_id=' + exercise_id);
        }
    }


    const handleExerciseTypesChange = (tag:number, checked:boolean) => {
        if(tag == 0){
            setSelectedTypes([0]);
            typeFilters.current = [1,2,3,4,5];
        }else{
            setSelectedTypes([tag]);
            typeFilters.current = [tag]     
        }
        page.current = 1;
        queryExerciseList();
      }


    const handleExerciseDifficultyChange = (tag:number, checked:boolean) => {
        if(tag == 0){
            setSelectedDifficulty([0]);
            difficultyFilters.current = [1,2,3];
            queryExerciseList();
        }else{
            setSelectedDifficulty([tag]);
            difficultyFilters.current = [tag]
        }
        page.current = 1;
        queryExerciseList();
 
    }


    return (
        <Layout style={{minHeight: 750,backgroundColor: '#f9f9f9'}}>
     <div className={exerciseStyles.maincontent}>
        <div className={exerciseStyles.exerciseList} style={{ width:'100%'}}  >
         
          <div className={exerciseStyles.mainTopDiv}>
              <div className={exerciseStyles.mainTopTitle}>
                  题库管理
              </div>

              <div className={exerciseStyles.mainTopDesp}>
                  浏览和管理课程习题和您的习题
              </div>
          </div>


            <div className={exerciseStyles.headerSearchDiv}>

              { (isLogin == true && isCollegeTeacher == 1) ?   <Row style={{ paddingRight: 24, marginBottom: 20 }}>
                    <Col flex={"auto"}>
                        <div>
                            <Input
                                onPressEnter={onSearchBtn} 
                                placeholder="搜索题目..." 
                                className={exerciseStyles.searchInput}
                                suffix={<SearchOutlined  style={{color:"#666666"}}/>}
                            />

                        </div>
                    </Col>

                    <Col flex={"160px"} style={{textAlign:'right'}}>
                        <div>
                            <span
                            
                            className={exerciseStyles.createBtn}
                            onClick={()=>{newName.current = ''; setSelectedType(1); showModal() }}
                            >
                            <PlusOutlined /> 创建题目
                            </span>
                            </div>
                    </Col>
                </Row> :  <Row style={{ paddingRight: 24, marginBottom: 20 }}>
                    <Col span={24}>
                        <div>
                            <Input
                                onPressEnter={onSearchBtn} 
                                placeholder="搜索题目..." 
                                className={exerciseStyles.searchInput}
                                suffix={<SearchOutlined  style={{color:"#666666"}}/>}
                            />

                        </div>
                    </Col>
                </Row>
                }

                <div className={exerciseStyles.filterWrapper} >
                        <div className={exerciseStyles.filterTitle} >难度筛选：</div>
                        {difficultyData?.map((value,index) => {
                        return <CheckableTag
                        style={{fontSize:14,borderRadius:20}}
                            key={index}
                            checked={selectedDifficulty.indexOf(index) > -1}
                            onChange={checked => handleExerciseDifficultyChange(index, checked)}
                        >
                            {value}
                        </CheckableTag>
                        })}
                </div>

                <div className={exerciseStyles.filterWrapper} >
                    <div className={exerciseStyles.filterTitle}  >题型筛选：</div>
                    {typesData?.map((value,index) => {
                        return <CheckableTag
                        style={{fontSize:14,borderRadius:20}}
                            key={index}
                            checked={selectedTypes.indexOf(index) > -1}
                            onChange={checked => handleExerciseTypesChange(index, checked)}
                        >
                            {value}
                        </CheckableTag>
                    })}
                       
                </div>




            </div>

            
            <Tabs  onChange={onTabKeyChange} defaultActiveKey="2" size="small" style={{ width:'100%'}} >
                
                <TabPane tab={<div><GlobalOutlined /> 平台</div>} key="2">
        
                    <div className={exerciseStyles.cardListWarpper}>
                        <Row gutter={[24, 24]} wrap={true} justify="start">
                            {exerciseResult?.map((exercise) => {
                                return (
                                    <Col key={exercise.id} span={8}>
                                        <div
                                            className={exerciseStyles.exeCard}
                                                
                                        >

                                            <Row align="middle" justify="start" gutter={[12,12]} style={{margin:'0 0 12px'}}>
                                                <Col span={12} style={{textAlign:"left"}}>
                                                    <div >
                                                        <span style={getExeTypeLabeStyle(exercise?.type)} >{getTypeName(exercise?.type)}</span>
                                                    </div>  
                                                </Col>
                                                <Col span={12} style={{textAlign:"right"}} >
                                                    <div >
                                                        <span style={getExeDifficultLabeStyle(exercise?.difficulty)} >{getDifficultName(exercise?.difficulty)}</span>
                                                    </div>  
                                                </Col>

                                            </Row>

                                            <div className={exerciseStyles.cardTitle}>
                                                {exercise?.title}
                                            </div>

                                            <div className={exerciseStyles.cardDescription}>
                                                    {exercise.steps}
                                            </div>

                                            <Row align="middle" justify="start" gutter={[12,12]} style={{margin:'0 0 12px'}}>
                                                <Col span={12} style={{textAlign:"left"}}>
                                                    <div className={exerciseStyles.exeCardTime}>
                                                        创建于 {exercise?.create_time?.slice(0,10)}
                                                    </div>  
                                                </Col>
                                                <Col span={12} style={{textAlign:"right"}} >
                                                    <div  style={{textAlign:'right'}}  >  <span className={exerciseStyles.cardLookBtn} onClick={onExerciseCardClick.bind(this, exercise.id)}  > 查看详情 <ArrowRightOutlined /> </span></div> 
                                                </Col>

                                            </Row>
                                            
                                        </div>
                                    </Col>
                                )
                            })}

                            
                        </Row>

                        {exerciseResult?.length == 0 &&
                            <div style={{textAlign:'center'}}> 
                            <img src={emptyExercise} height={150}/> 
                            <div style={{color:"#999999"}}>没有找到满足条件的习题~
                                    
                            </div>
                            
                            </div>
                        }
                    </div>


                </TabPane>
                { isLogin == true && isCollegeTeacher == 1 &&
                <TabPane tab={<div><UserOutlined /> 我的</div>} key="1">
                <div className={exerciseStyles.cardListWarpper}>
                    <Row gutter={[24, 24]} wrap={true} justify="start">
                        {exerciseResult?.map((exercise) => {
                            return (
                                <Col key={exercise.id} span={8}>  

                                  <div
                                        className={exerciseStyles.exeCard}
                                               
                                    >

                                        <Row align="middle" justify="start" gutter={[12,12]} style={{margin:'0 0 12px'}}>
                                            <Col span={12} style={{textAlign:"left"}}>
                                                <div >
                                                    <span style={getExeTypeLabeStyle(exercise?.type)} >{getTypeName(exercise?.type)}</span>
                                                </div>  
                                            </Col>
                                            <Col span={12} style={{textAlign:"right"}} >
                                                <div >
                                                    <span style={getExeDifficultLabeStyle(exercise?.difficulty)} >{getDifficultName(exercise?.difficulty)}</span>
                                                </div>  
                                            </Col>

                                        </Row>

                                        <div className={exerciseStyles.cardTitle}>
                                            {exercise?.title}
                                        </div>

                                        <div className={exerciseStyles.cardDescription}>
                                                {exercise.steps}
                                        </div>

                                        <Row align="middle" justify="start" gutter={[12,12]} style={{margin:'0 0 12px'}}>
                                            <Col flex={"160px"} style={{textAlign:"left"}}>
                                                <div className={exerciseStyles.exeCardTime}>
                                                    创建于 {exercise?.create_time?.slice(0,10)}
                                                </div>  
                                            </Col>
                                            <Col flex={"auto"} style={{textAlign:"right"}} >
                                                 <div  style={{textAlign:'right'}}  >  

                                                    <Popconfirm placement="bottom" title={'您确定删除此习题吗？'} onCancel={(e:any)=>{e.stopPropagation();}} onConfirm={(e:any)=>{e.stopPropagation();deleteExercise(exercise.id)}} okText="确认" cancelText="取消">
                                               
                                                        <span onClick={(e:any)=>{e.stopPropagation();}} className={exerciseStyles.cardDeleteBtn}   > 
                                                            删除
                                                        </span>

                                                    </Popconfirm> 

                                                    <span className={exerciseStyles.cardEditBtn} onClick={onExerciseEditClick.bind(this, exercise.id)}  > 
                                                        编辑
                                                    </span>

                                                    <span className={exerciseStyles.cardViewBtn} onClick={onExerciseCardClick.bind(this, exercise.id)}  > 
                                                        查看
                                                    </span>
                                                 </div> 
                                            </Col>

                                        </Row>
                                        
                                    </div>
                              
                                </Col>
                            )
                        })}
                    </Row>

                    {exerciseResult?.length == 0 &&
                    <div style={{textAlign:'center'}}> 
                       <img src={emptyExercise} height={150}/> 
                       <div style={{color:"#999999"}}>您还没有创建题目哟~ 
                            
                       </div>
                       <Button size="small" style={{border:"1px solid #07c176",color:"#07c176",marginTop:10,borderRadius:3}} type="default" onClick={showModal}> 立即创建
                             </Button>
                    </div>
                    }

                    </div>

                        
                 </TabPane>
                    }
                </Tabs>

            <ConfigProvider locale={zhCN}>

              <div style={{ marginBottom: 30, paddingTop: 30, textAlign:'center' }}
                  className={'css.pagination'}>
                <Pagination
                  defaultCurrent={1}
                  current={page.current}
                  total={resultSum}
                  defaultPageSize={9}
                  hideOnSinglePage={true} 
                  onChange={onPageChange}
                  showSizeChanger={false}
                />
              </div>
            </ConfigProvider>
                 
        </div>

        </div>

        <Modal 
            title={<div style={{ width: '100%',cursor: 'move',}}
            onMouseOver={() => {if (disabled) {setExeCardModalDisabled(false)}}}
            onMouseOut={() => {setExeCardModalDisabled(true)}}
            onFocus={() => {}}
            onBlur={() => {}}
            >
                提示</div>
            }
            width={350}
            closable={false}
            open={isExeCardModalVisible}
            className={courseMainStyles.miniModal}
            footer={
                <div>
                {isLogin == true && collegeId > 0 && isCollegeTeacher == 0 &&
                    <Button className={courseMainStyles.stepsBtn}
                    style={{marginRight:20,color:'#fff',  textShadow: 'none', boxShadow:'none'}}
                    type="primary"
                    onClick={()=>{setIsExeCardModalVisible(false)}}>确认</Button>
                }
                {isLogin == true && (collegeId == 0 ||  collegeId == null || collegeId == '')  &&
                    <div>
                        <Button className={courseMainStyles.stepsBtn}
                        style={{marginRight:20,color:'#07c160', textShadow: 'none', boxShadow:'none'}}
                        onClick={()=>{setIsExeCardModalVisible(false)}}>取消</Button>
                        <Button className={courseMainStyles.stepsBtn}
                        style={{marginRight:20,color:'#fff',textShadow: 'none', boxShadow:'none'}}
                        type="primary"
                        onClick={()=>{window.open("/user-center")}}>填写</Button></div>
                    }
                </div>
            }
            modalRender={modal => (<div>
                <Draggable
                disabled={exeCardModalDisabled}
                bounds={exeCardModalbounds}
                onStart={(event, uiData) => onExeCardModalStart(event, uiData)}
                >
                <div ref={draggleRef}>{modal}</div>
                </Draggable> </div>
            )}
            >
                {isLogin == true && collegeId > 0 && isCollegeTeacher == 0 &&
                    <div style={{width:300,textAlign:'center',paddingTop:20}}>
                        <p>只有教师可以查看题目哦~</p>  
                </div>}

                {isLogin == true && (collegeId == 0 ||  collegeId == null || collegeId == '')  &&
                    <div style={{width:320,textAlign:'center',paddingTop:20}}>
                    您还没加入院校，如需查看题目，请填写院校码。
                    {/* <span><Button type="link" onClick={()=>{window.open("/user-center")}}>填写</Button> </span> 院校码。 */}
                    <p>获取院校码，请咨询：136 9329 0406</p>
                </div>
               }
        </Modal>

     

        <Modal
                            title={<div
                            style={{
                            width: '100%',
                            cursor: 'move',
                            }}
                            onMouseOver={() => {
                            if (disabled) {
                                setDisabled(false)
                            }
                            }}
                            onMouseOut={() => {
                            setDisabled(true)
                            }}
                            onFocus={() => {}}
                            onBlur={() => {}}
                            // end
                        >
                            创建题目
                        </div>
                        }
                        closable={false}
                        open={isModalVisible}
                        onOk={handleOk}
                        onCancel={handleCancel}
                        bodyStyle={{ }}
                        destroyOnClose={true}
                        width={900}
                        modalRender={modal => (<div className={exerciseStyles.createDiv}>
                            <Draggable
                            disabled={disabled}
                            bounds={bounds}
                            onStart={(event, uiData) => onStart(event, uiData)}
                            >
                            <div ref={draggleRef}>{modal}</div>
                            </Draggable> </div>
                        )}
                        >
                            
                            <Row
                                gutter={[8, 8]}
                                justify="start"
                                align="middle"
                                style={{ marginBottom: 15 }}
                            >
                                <Col className={GlobalCss.requiredLabel}>
                                名称
                                </Col>
                                <Col flex="auto" style={{ textAlign: 'left'}}>
                                <Input
                                style={{width:300}}
                                    placeholder="请输入题目名称"
                                    required={true}
                                    onChange={(e) => {  newName.current = e.target.value}}
                                />
                                </Col>
                            </Row>

                            <Radio.Group 
                            defaultValue={"1"} 
                            buttonStyle="solid"
                            onChange={(e:any) => {setSelectedType(e.target.value)}}>
                                <Radio.Button value="1">  
                                <div >
                                        <CodeOutlined />
                                        <div >实操题 </div>
                                    </div></Radio.Button>
                                <Radio.Button value="2">
                                    <div>
                                    <CheckCircleOutlined />
                                    <div  > 单选题 </div>
                                    </div></Radio.Button>
                                <Radio.Button value="3"> <div>
                                    <CheckSquareOutlined />
                                    <div  >多选题 </div>
                                    </div></Radio.Button>
                                <Radio.Button value="4">
                                    <div >
                                        <SortDescendingOutlined />
                                        <div > 排序题</div>
                                    </div></Radio.Button>
                                <Radio.Button value="5"><div >
                                    <EditOutlined />
                                    <div > 主观题 </div>
                                    </div></Radio.Button>
                            </Radio.Group>
                     
                 </Modal>


        </Layout>

    )

}

export default ExerciseList